import { debounce } from 'lodash';
import { useEffect, useMemo, useState } from 'react';
import { useQuery } from 'react-query';
import { GetWebhookSignalDetails } from 'services/apiServices';
import { Errors, TWebHookSignalResult } from 'types/ApiServicesTypes';
const WAIT_INTERVAL = 300;

export default function useGetWebHookSignalDetails(
  botId: number,
  page = 1,
  pageSize = 15,
) {
  const [currentPage, setCurrentPage] = useState(page);

  const objQuery = useQuery<TWebHookSignalResult, Errors>(
    ['webhooksignaldetail', botId, currentPage],
    () => GetWebhookSignalDetails(botId, currentPage, pageSize),
  );
  const { refetch } = objQuery;

  const debouncedRefetch = useMemo(() => {
    return debounce(refetch, WAIT_INTERVAL);
  }, [refetch]);

// When `botId`  changes, reset the page to 1 and refetch
  useEffect(() => {
    setCurrentPage(1);
    void debouncedRefetch();
  }, [botId, debouncedRefetch]);

  // If the page changes, refetch the data
  useEffect(() => {
    void refetch();
  }, [currentPage, refetch]);

  return {
    ...objQuery,
    currentPage,
    setCurrentPage,
  };
}
